const custMenu = {
	ZZ: {
		shortName: ['外掛', 'plug-in.', '外挂'],
		name: ['外掛', 'plug-in', '外挂'],
		ico: 'suitcase',
		hint: [],
		children: {
			ZZ1: {
				name: ['出勤', 'Attendance hours', '出勤'],
				children: {
					ZZ_COMMON_AM10010: {
						name: ['出勤模擬試算', 'Attendance Simulation', '出勤模拟试算'],
						url: '/zz_common_am10010',
						hint: [],
					},
				},
			},
			ZZ2: {
				name: ['薪資報表', 'Salary report', '薪资报表'],
				children: {
					ZZ_SYUGUANG_PB00101: {
						name: ['薪資明細表表頭設定', 'Salary statement header setup', '薪资明细表表头设置'],
						url: '/zz_common_pb10020',
						hint: [],
						ZZ_SYUGUANG_PB00101: { name: ['薪資明細表表頭設定', 'Salary statement header setup', '薪资明细表表头设置'] },
					},
					ZZ_SYUGUANG_PB00102: {
						name: ['薪資報表', 'Salary report', '薪资报表'],
						url: '/zz_common_pb10021',
						hint: [],
						ZZ_SYUGUANG_PB00102: { name: ['薪資報表', 'Salary report', '薪资报表'] }, 
					},					
				},
			},			
			ZZ_ENPHANTS1: {
				name: ['(客製)出勤', '(客製)Attendance hours', '(客製)出勤'],
				children: {
					ZZ_ENPHANTS_AM10010: {
						name: ['(客製)差勤結算設定', '(客製)差勤結算設定', '(客製)差勤結算設定'],
						url: '/zz_enphants_am10010',
						hint: [],
					},			
					ZZ_LESENPHANTS_AM50050: {
						name: ['(客製)特殊出勤作業查詢', '(客製)特殊出勤作業查詢', '(客製)特殊出勤作業查詢'],
						url: '/zz_lesenphants_am50050',
						hint: [],
					},
					ZZ_LESENPHANTS_AM50051: {
						name: ['(客製)特殊出勤計算作業', '(客製)特殊出勤計算作業', '(客製)特殊出勤計算作業'],
						url: '/zz_lesenphants_am50051',
						hint: [],
					},
				},
			},
			ZZ_ENPHANTS2: {
				name: ['(客製)人事', '(客製)Staff', '(客製)人事'],
				children: {
					ZZ_ENPHANTS_ED10010: {
						name: ['(客製)新進員工設定', '(客製)新進員工設定', '(客製)新進員工設定'],
						url: '/zz_enphants_ed10010',
						hint: [],
					},
				},
			},
			ZZ_ENPHANTS3: {
				name: ['(客製)門市出勤作業', '(客製)門市出勤作業', '(客製)門市出勤作業'],
				children: {
					ZZ_ENPHANTS_AM40031: {
						name: ['(客製)門市打卡設定', '(客製)門市打卡設定', '(客製)門市打卡設定'],
						url: '/zz_enphants_am40031',
						hint: [],
						ZZ_ENPHANTS_AM40031: { name: ['(客製)門市打卡設定', '(客製)門市打卡設定', '(客製)門市打卡設定'] },
					},
					ZZ_ENPHANTS_AM40032: {
						name: ['(客製)門市打卡明細', '(客製)門市打卡明細', '(客製)門市打卡明細'],
						url: '/zz_enphants_am40032',
						hint: [],
						ZZ_ENPHANTS_AM40032: { name: ['(客製)門市打卡明細', '(客製)門市打卡明細', '(客製)門市打卡明細'] }, 
					},					
				},
			},
			ZZ_ENPHANTS4: {
				name: ['(客製)傳票設定', '(客製)傳票設定', '(客製)傳票設定'],
				children: {
					ZZ_ENPHANTS_PB10030: {
						name: ['(客製)傳票設定', '(客製)Accountting Settings', '(客製)传票设定'],
						url: '/zz_enphants_pb10030',
						hint: [],
						children: {
							ZZ_ENPHANTS_PB10030: { name: ['(客製)傳票設定', '', ''] },
							ZZ_ENPHANTS_PB10031: { name: ['(客製)傳票匯出', '', ''] },
						},
					},
				},	
			},

		},
	},
};

module.exports = (paidMenu) => {
	return { ...paidMenu, ...custMenu };
};